import script from "./TaskBatchStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskBatchStatus.vue?vue&type=script&setup=true&lang=js"

import "./TaskBatchStatus.vue?vue&type=style&index=0&id=7cd0c942&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cd0c942"]])

export default __exports__